export default __webpack_public_path__ + "static/media/flag1.6a2b26c2.jpg";